<!-- GenericBoard.vue (in components folder) -->
<template>
    <div class="contents">
      <table class="tbl_list">
        <thead>
          <tr>
            <th v-for="(header, index) in headers" :key="header" :style="{ width: columnWidths[index] }">
            {{ header }}
          </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in paginatedItems" :key="index">
            <td v-for="(key, colIndex) in Object.keys(item)" :key="key" :style="{ width: columnWidths[colIndex] }">
             {{ item[key] }}
            </td>
          </tr>
        </tbody>
      </table>
  
      <div class="pagination_area">
        <div class="pagination clearfix">
          <button class="page_nav prev" :disabled="currentPage === 1" @click="prevPage">
            <span class="blind">이전</span>
          </button>
          <template v-for="page in totalPages" :key="page">
            <a href="javascript:;" :class="{ active: page === currentPage }" @click="goToPage(page)">
              {{ page }}
            </a>
          </template>
          <button class="page_nav next" :disabled="currentPage === totalPages" @click="nextPage">
            <span class="blind">다음</span>
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      headers: {
        type: Array,
        required: true
      },
      items: {
        type: Array,
        required: true
      },
      itemsPerPage: {
        type: Number,
        default: 10
      },
      columnWidths: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        currentPage: 1
      }
    },
    computed: {
      totalPages() {
        return Math.ceil(this.items.length / this.itemsPerPage)
      },
      paginatedItems() {
        const start = (this.currentPage - 1) * this.itemsPerPage
        const end = start + this.itemsPerPage
        return this.items.slice(start, end)
      }
    },
    methods: {
      prevPage() {
        if (this.currentPage > 1) {
          this.currentPage--
        }
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++
        }
      },
      goToPage(page) {
        this.currentPage = page
      }
    }
  }
  </script>
  
  <style scoped>
.contents {
    position: relative;
    width: 1280px;
    margin: 0 auto;
    padding-bottom: 100px;
}

body {
    color: #333;
    font-size: 16px;
    font-family: 'NanumSquareRound', Malgun Gothic, '맑은고딕', Dotum, '굴림', Gulim, Helvetica, sans-serif;
    line-height: 1.5;
    background-color: #f7f8fa;
}

table {
    border-collapse: separate;
    text-indent: initial;
    border-spacing: 2px;
}

table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    border-spacing: 0;
}

th {
    display: table-cell;
    vertical-align: inherit;
    font-weight: bold;
    text-align: -internal-center;
    unicode-bidi: isolate;
}

.tbl_list thead th {
    height: 46px;
    line-height: 21px;
    text-align: center;
    vertical-align: middle;
    color: #fff;
    border-right: 1px solid #5185f5;
    background-color: #5f93fa;
}

.tbl_list thead tr:nth-child(1) th:first-child {
    border-radius: 12px 0 0 0;
}

.tbl_list thead tr:nth-child(1) th:last-child {
    border-radius: 0 12px 0 0;
}

.tbl_list thead th:last-child, .tbl_list tbody td:last-child {
    border-right: none;
}

td {
    display: table-cell;
    vertical-align: inherit;
    unicode-bidi: isolate;
}

.tbl_list tbody th, .tbl_list tbody td {
    position: relative;
    height: 46px;
    padding: 9px 16px;
    text-align: center;
    vertical-align: middle;
    border-bottom: 1px solid #eaeaea;
    border-right: 1px solid #eaeaea;
    background-color: #fff;
}

.tbl_list tbody tr:last-child td:nth-child(1) {
    border-bottom-left-radius: 12px;
}
  
.tbl_list tbody tr:last-child td:last-child {
    border-bottom-right-radius: 12px;
}

.tbl_list tbody tr:last-child td {
    border-bottom: none;
}

.tbl_list thead th:last-child, .tbl_list tbody td:last-child {
    border-right: none;
}

div {
    display: block;
    unicode-bidi: isolate;
}
 

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 40px;
    color: #959595;
    font-size: 16px;
    text-align: center;
}

button {
    appearance: auto; 
    text-rendering: auto;
    color: buttontext;
    letter-spacing: normal;
    word-spacing: normal;
    line-height: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: center;
    align-items: flex-start;
    cursor: default;
    box-sizing: border-box;
    background-color: buttonface;
    margin: 0em;
    padding-block: 1px;
    padding-inline: 6px;
    border-width: 2px;
    border-style: outset;
    border-color: buttonborder;
    border-image: initial;
}

button:disabled {
    background-color: light-dark(rgba(239, 239, 239, 0.3), rgba(19, 1, 1, 0.3));
    color: light-dark(rgba(16, 16, 16, 0.3), rgba(255, 255, 255, 0.3));
    border-color: light-dark(rgba(118, 118, 118, 0.3), rgba(195, 195, 195, 0.3));
}

input, select, textarea, button {
    font-family: inherit;
    vertical-align: middle;
    box-sizing: border-box;
}

.pagination .page_nav {
    width: 40px;
    height: 40px;
    padding: 0;
    border: 1px solid #eaeaea;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-position: 50% 50%;
}

.pagination .prev {
    margin-right: 24px;
    background-image: url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2220%22%20height%3D%2220%22%20preserveAspectRatio%3D%22xMidYMid%20meet%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22%23959595%22%20d%3D%22M15.41%207.41L14%206l-6%206l6%206l1.41-1.41L10.83%2012l4.58-4.59z%22%2F%3E%3C%2Fsvg%3E);
}

.pagination .page_nav.disabled {
    cursor: default;
}

.pagination a.active, .pagination span.active {
    color: #ed1b23;
    font-weight: 700;
}

.pagination a, .pagination span {
    display: block;
    min-width: 40px;
    color: #959595;
    padding: 0 4px;
}

a {
    color: #333;
    text-decoration: none;
}

a:-webkit-any-link { 
    cursor: pointer; 
}
 
.pagination .next {
    margin-left: 24px;
    background-image: url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2220%22%20height%3D%2220%22%20preserveAspectRatio%3D%22xMidYMid%20meet%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22%23959595%22%20d%3D%22M10%206L8.59%207.41L13.17%2012l-4.58%204.59L10%2018l6-6l-6-6z%22%2F%3E%3C%2Fsvg%3E);
}

.blind {
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    clip: rect(0, 0, 0, 0);
}
  </style>
  